/* eslint-disable no-undefined */
export default function convertTimeToDecimal(time) {
  if (!time) {
    // throw new Error('Missing time argument')
    return 'Missing time argument'
  }

  const [hour, minutes] = time.split(':')

  if (hour === undefined || minutes === undefined) {
    // throw new Error('Invalid time format')
    return 'Invalid time format'
  }

  const minutesFloat = 1 / (60 / parseInt(minutes, 10))

  return parseInt(hour, 10) + minutesFloat
}
